var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "full-height",
      staticStyle: { padding: "20px", "padding-bottom": "0", height: "100%" },
    },
    [
      _c(
        "div",
        { staticStyle: { "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            {
              attrs: { inline: true },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "搜尋" } },
                [
                  _c("el-input", {
                    attrs: { size: "mini", placeholder: "輸入查詢" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleFilter($event)
                      },
                    },
                    model: {
                      value: _vm.listQuery.qry,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "qry", $$v)
                      },
                      expression: "listQuery.qry",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      attrs: {
                        size: "mini",
                        type: "primary",
                        icon: "el-icon-search",
                      },
                      on: { click: _vm.handleFilter },
                    },
                    [_vm._v(" 搜尋 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.addData },
                    },
                    [_vm._v("建立")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
                "row-key": "id",
                "tree-props": {
                  children: "children",
                  hasChildren: "hasChildren",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "ID", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.id))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "圖片", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          staticStyle: { height: "50px" },
                          attrs: {
                            src:
                              scope.row.fileInfo.length > 0
                                ? scope.row.fileInfo[0].files[0].url
                                : "https://fakeimg.pl/420x250/",
                            fit: "contain",
                            "preview-src-list": _vm.fileUrl(scope.row.fileInfo),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "標題", width: "250" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.title))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "描述", width: "250" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.introduction))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "外部連結", width: "250" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          { attrs: { href: scope.row.url, target: "_blank" } },
                          [
                            _c(
                              "span",
                              { staticStyle: { color: "rgb(64, 158, 255)" } },
                              [_vm._v(_vm._s(scope.row.url))]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "編輯", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v("編輯")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "刪除", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope)
                              },
                            },
                          },
                          [_vm._v("刪除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0", "margin-top": "15px" },
        attrs: {
          layout: "total, prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _c(
        "el-dialog",
        {
          staticStyle: { border: "2px solid #ccc" },
          attrs: {
            title: "編輯",
            visible: _vm.dialogFormVisible,
            width: "90%",
            top: "1%",
          },
          on: {
            closed: _vm.onDialogClosed,
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.formLoading,
                  expression: "formLoading",
                },
              ],
              staticClass: "box-card",
              attrs: { "body-style": { border: "1px solid #ccc" } },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "dynamicValidateForm",
                          attrs: { model: _vm.formData },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "圖片",
                                "label-width": _vm.formLabelWidth,
                              },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("Upload", {
                                    ref: "uploadRef",
                                    attrs: {
                                      accept: ".jpg,.jpeg,.png",
                                      payload: _vm.formData,
                                      "data-obj": _vm.fileObj,
                                      limitText:
                                        "圖片尺寸:420x250，須為.jpg,.jpeg,.png格式，限制不超過2000MB",
                                      "limit-file-count": 1,
                                      "use-drag": false,
                                      action: "ToursCombine/saveHotCountry",
                                      "auto-upload": false,
                                      "show-file-list": true,
                                      "form-on-loading-parent": _vm.formLoading,
                                      "btn-txt": "上傳",
                                      "before-file-list": _vm.coverFileList,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "標題",
                                "label-width": _vm.formLabelWidth,
                                prop: "title",
                                rules: [
                                  {
                                    required: true,
                                    message: "請輸入標題",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { autocomplete: "off" },
                                model: {
                                  value: _vm.formData.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "title", $$v)
                                  },
                                  expression: "formData.title",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "描述",
                                "label-width": _vm.formLabelWidth,
                                prop: "introduction",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  autocomplete: "off",
                                  maxlength: "50",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.formData.introduction,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "introduction", $$v)
                                  },
                                  expression: "formData.introduction",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "外部連結",
                                "label-width": _vm.formLabelWidth,
                                prop: "title",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { autocomplete: "off" },
                                model: {
                                  value: _vm.formData.url,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "url", $$v)
                                  },
                                  expression: "formData.url",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "內容",
                                "label-width": _vm.formLabelWidth,
                                prop: "articleContent",
                              },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("tinymce", {
                                    ref: "tinymce",
                                    attrs: { height: 500, type: 29 },
                                    model: {
                                      value: _vm.formData.articleContent,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "articleContent",
                                          $$v
                                        )
                                      },
                                      expression: "formData.articleContent",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "發文日期",
                                "label-width": _vm.formLabelWidth,
                                prop: "buildDate",
                                rules: [
                                  {
                                    required: true,
                                    message: "請選擇發文日期",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "請選擇發文日期",
                                  format: "yyyy 年 MM 月 dd 日",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.formData.buildDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "buildDate", $$v)
                                  },
                                  expression: "formData.buildDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveData("dynamicValidateForm")
                    },
                  },
                },
                [_vm._v("儲 存")]
              ),
              _c("el-button", { on: { click: _vm.onDialogClosed } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }